export enum OrganizationSettingDefaultValue {
  ENABLED = 'enable',
  DISABLED = 'disable',
}

export enum OrganizationSettingBoolValue {
  TRUE = 'true',
  FALSE = 'false',
}

export enum OrganizationSettingDisplayUnitsValue {
  ALL = 'all',
  DISPLAY = 'display',
  CONSUMER_UNITS = 'consumerunits',
}

export enum OrganizationSettingSpecificExportType {
  XLSX = 'xlsx',
}

export interface OrganizationSettingSpecificExport {
  name: string;
  type: OrganizationSettingSpecificExportType | string;
}

export interface OrganizationSettings {
  acceptedsourcing?: OrganizationSettingDefaultValue | null;
  assignation?: OrganizationSettingDefaultValue | null;
  auto_accept_share_create?: OrganizationSettingDefaultValue | null;
  auto_accept_share_update?: OrganizationSettingDefaultValue | null;
  autopublish?: OrganizationSettingDefaultValue | null;
  bigmanufacturer?: OrganizationSettingBoolValue | null;
  'chat.organization.enabled'?: OrganizationSettingBoolValue | null;
  'chat.productversion.enabled'?: OrganizationSettingBoolValue | null;
  eligibleforsourcing?: OrganizationSettingDefaultValue | null;
  export_synchronization_status?: OrganizationSettingDefaultValue | null;
  grouppermissions?: OrganizationSettingDefaultValue | null;
  gtinallocationrules?: OrganizationSettingDefaultValue | null;
  hpp?: any | null;
  'price.displayunits'?: OrganizationSettingDisplayUnitsValue | null;
  rfp?: OrganizationSettingDefaultValue | null;
  sourcingdata?: any | null;
  'sourcinglabel.share'?: OrganizationSettingDefaultValue | null;
  specific_exports?: OrganizationSettingSpecificExport[] | null;
  ui_max_idle_time?: number | null;
  viewsourcing?: OrganizationSettingDefaultValue | null;
  [key: string]: any;
}
